/* eslint-disable */
import axios from 'axios'

const searchBoxService = {
    getAirlines(){
        return new Promise((resolve)=>{
            let data = "";
            axios.post(
                "/api/Go/GetAirlines_Responsive",
                data
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });                
    },
    getCityAirportsFromApi(searchText){
        return new Promise((resolve)=>{
            let data = "";
            if (searchText!=null) data = "searchText=" + searchText;
            axios.post(
                "/api/Go/GetAirportsFromApi",
                data
            ).then(rslt=>{
                let airports = [];
                let obj = rslt.data;

                if (obj[0]=="IsNotThai") {
                  let items = obj[1][1];
                  items.forEach(a => {
                    let arp = a[3];
                    if (arp.a != ""){
                      let airport = `${arp.a} - ${arp.h}`;
                      airports.push(airport);
                    }
                  });
                }else {
                  let items = obj[1];
                  items.forEach(a => {
                    if(a.AirportCode!=""){
                      let airport = `${a.AirportCode} - ${a.AirportName}`;
                      airports.push(airport);
                    }
                  });
                }
                resolve({data: airports});
            }).catch(()=>{
            });
        });        
    },
    getCityAirports(searchText){
        return new Promise((resolve)=>{
            let data = "";
            if (searchText!=null) data = "searchInput=" + searchText;
            axios.post(
                "/api/Go/SearchCityAirport_Responsive",
                data
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });        
    },
    decodeFlightSearchBoxValues(text){
        return new Promise((resolve)=>{
            let data = "";
            if (text!=null) data = "requestId=" + text;
            axios.post(
                "/api/Go/DecodeFlightSearchBoxValues",
                data
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });          
    },
    getSearchResultUrl(sid){
        return new Promise((resolve)=>{
            let data = sid!=null? {sid:sid}:null;
            axios.post(
                "/api/Go/GetSearchResultUrl",
                data
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });          
    },    
    getSharedSearchResultUrl(){
        return new Promise((resolve)=>{
            let data = null;
            axios.post(
                "/api/Go/GetSharedSearchResultUrl",
                data
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });          
    },     
    getBackToHomeUrl(){
        return new Promise((resolve)=>{
            let data = null;
            axios.post(
                "/api/Go/GetBackToHomeUrl",
                data
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });           
    },
}

export default searchBoxService;